import { createStyles, Divider, makeStyles } from '@material-ui/core';
import React from 'react';
import { BrandColors } from '../../constants';

export const NeutralDividerStyles = makeStyles(() =>
  createStyles({
    divider: {
      backgroundColor: BrandColors.grey80,
      borderRadius: 8,
      width: '100%',
      height: '2px',
      opacity: 0.5,
    },
  }),
);

interface NeutralDividerProps {
  className?: string;
}

export const NeutralDivider = ({ className }: NeutralDividerProps): JSX.Element => {
  const classes = NeutralDividerStyles();
  const classNames = [classes.divider, className].filter(Boolean).join(' ');

  return <Divider className={classNames} />;
};
